import { ref } from 'vue';
import { AbstractQueryParams, QueryString } from 'SharedDir/common/composables/useQueryString';

export type Filters = {
  title?: string | null;
  fromDate?: string | null;
  toDate?: string | null;
  source?: string | null;
};

export function usePublicNewsFilters() {
  const defaultFilterParams = (): Filters => ({
    title: null,
    fromDate: null,
    toDate: null,
    source: null,
  });

  const filterParams = ref<Filters>(defaultFilterParams());

  const sanitizeQueryFilterParams = (): AbstractQueryParams => ({
    title: QueryString,
    fromDate: QueryString,
    toDate: QueryString,
    source: QueryString,
  });

  return {
    filterParams,
    defaultFilterParams,
    sanitizeQueryFilterParams,
  };
}
